import { render, staticRenderFns } from "./performanceAssessment.vue?vue&type=template&id=15e6e1d5&scoped=true&"
import script from "./performanceAssessment.vue?vue&type=script&lang=js&"
export * from "./performanceAssessment.vue?vue&type=script&lang=js&"
import style0 from "./performanceAssessment.vue?vue&type=style&index=0&id=15e6e1d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e6e1d5",
  null
  
)

export default component.exports